import React, { Fragment, useEffect, useState } from "react";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import styles from "./Cart.module.css";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link } from "react-router-dom";
import backBoardPic from "../../Assets/frames/BackingBoard.webp";
import Parse from "../../API/ParseServer";
const FrameItem: React.FC<{
  item: any;
  pricing: any;
  updateTotal: any;
  loseDiscount: any;
}> = (props) => {
  const [inputQuantity, setInputQuantity] = useState(
    Number(props.item.quantity),
  );
  const [quantity, setQuantity] = useState(1000);
  const [quantityloading, setQuantityloading] = useState(false);
  const uid = function () {
    return (
      Date.now().toString(36) +
      Math.floor(
        Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12),
      ).toString(36)
    );
  };
  const guestId = localStorage.getItem("guestId")
    ? localStorage.getItem("guestId")
    : uid();
  const quantityDecHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      inputQuantity !== 1 &&
      !quantityloading &&
      (user || localStorage.getItem("guestId")) &&
      (await props.loseDiscount(props.item.itemId, false))
    ) {
      setQuantityloading(true);
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: "",
            quantity: inputQuantity - 1,
            frameId: frame.id,
            specifications: {
              glass: props.item.specifications.glass,
              mountboard: props.item.specifications.mountboard,
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Frame",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: "",
            quantity: inputQuantity - 1,
            frameId: frame.id,
            specifications: {
              glass: props.item.specifications.glass,
              mountboard: props.item.specifications.mountboard,
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Frame",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) setInputQuantity((current) => current - 1);
        setQuantityloading(false);
        props.updateTotal();
      }
    }
  };
  const quantityIncHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      inputQuantity < quantity &&
      !quantityloading &&
      (user || localStorage.getItem("guestId"))
    ) {
      setQuantityloading(true);
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: "",
            quantity: inputQuantity + 1,
            frameId: frame.id,
            specifications: {
              glass: props.item.specifications.glass,
              mountboard: props.item.specifications.mountboard,
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Frame",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: "",
            quantity: inputQuantity + 1,
            frameId: frame.id,
            specifications: {
              glass: props.item.specifications.glass,
              mountboard: props.item.specifications.mountboard,
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Frame",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) setInputQuantity((current) => current + 1);
        setQuantityloading(false);
        props.updateTotal();
      }
    }
  };
  const deleteHandler = async () => {
    const user = Parse.User.current();
    let response;
    if (
      (user || localStorage.getItem("guestId")) &&
      (await props.loseDiscount(props.item.itemId, true))
    ) {
      try {
        if (user)
          response = await Parse.Cloud.run("addToBasket", {
            user: user.id,
            artworkId: "",
            quantity: 0,
            frameId: frame.id,
            specifications: {
              glass: props.item.specifications.glass,
              mountboard: props.item.specifications.mountboard,
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Frame",
            itemId: props.item.itemId,
          });
        else {
          response = await Parse.Cloud.run("addToBasket", {
            user: guestId,
            artworkId: "",
            quantity: 0,
            frameId: frame.id,
            specifications: {
              glass: props.item.specifications.glass,
              mountboard: props.item.specifications.mountboard,
              width: Number(props.item.specifications.width),
              height: Number(props.item.specifications.height),
            },
            type: "Frame",
            itemId: props.item.itemId,
          });
          if (guestId) localStorage.setItem("guestId", guestId);
        }
      } catch (error) {
        console.log(error);
      } finally {
        if (response) window.location.reload();
        props.updateTotal();
      }
    }
  };
  const frame = props.item.frame;
  const perimeter = Number(
    (Number(props.item.specifications.width) +
      Number(props.item.specifications.height) +
      (props.item.specifications.mountboard.color
        ? 4 * Number(props.item.specifications.mountboard.size)
        : 0)) *
      2,
  );
  const area =
    (Number(props.item.specifications.width) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0)) *
    (Number(props.item.specifications.height) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0));
  const frameArea =
    (Number(props.item.specifications.width) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0) +
      (frame.get("style") === "tray" ? 2 : 0) +
      (2 * frame.get("width")) / 10) *
    (Number(props.item.specifications.height) +
      (props.item.specifications.mountboard.color
        ? 2 * Number(props.item.specifications.mountboard.size)
        : 0) +
      (frame.get("style") === "tray" ? 2 : 0) +
      (2 * frame.get("width")) / 10);
  const criteria =
    window.screen.width < 900
      ? "m"
      : Number(props.item.specifications.width) <
          Number(props.item.specifications.height)
        ? "hl"
        : "wl";
  const cm =
    Math.max(
      Number(props.item.specifications.width),
      Number(props.item.specifications.height),
    ) < 7
      ? 25 -
        (Number(props.item.specifications.mountboard.size) * 2 || 0) -
        frame.get("width") / 5
      : window.screen.width < 900
        ? (window.screen.width * 0.8) /
          (Number(props.item.specifications.width) +
            frame.get("width") / 5 +
            (Number(props.item.specifications.mountboard.size) * 2 || 0))
        : Number(props.item.specifications.width) <
            Number(props.item.specifications.height)
          ? 250 /
            (Number(props.item.specifications.height) +
              frame.get("width") / 5 +
              (Number(props.item.specifications.mountboard.size) || 0))
          : (window.screen.width < 1200
              ? window.screen.width * 0.2
              : 1200 * 0.2) /
            (Number(props.item.specifications.width) +
              frame.get("width") / 5 +
              (Number(props.item.specifications.mountboard.size) || 0));
  const VAT = props.pricing ? props.pricing.get("VAT") : 0.2;
  const multiplierFactor = props.pricing
    ? props.pricing.get("multiplierFactor")
    : 4;
  const mount = props.pricing ? props.pricing.get("mount_cm2") : 0.00105;
  const UVAcrylic2mm = props.pricing
    ? props.pricing.get("UVAcrylic2mm_cm2")
    : 0.00175;
  const UV99Acrylic2mm = props.pricing
    ? props.pricing.get("UV99Acrylic2mm_cm2")
    : 0.00175;
  const hanging = props.pricing ? props.pricing.get("hanging") : 0.2;
  const packing = props.pricing ? props.pricing.get("packing_cm2") : 0.001;
  const backBoard = props.pricing
    ? props.pricing.get("backBoard_cm2")
    : 0.00027;
  const tray = frame.get("style") === "tray" ? 1 : 0;
  function addCommas(num: number | String) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return (
    <Grid sx={{ width: "100%", borderBottom: "2px solid #f3f4f5" }} container>
      <Grid
        md={4}
        xs={12}
        item
        sx={{
          py: 4,
          display: "flex",
          justifyContent: "center",
          height: `${
            (Number(props.item.specifications.height) +
              (Number(props.item.specifications.mountboard.size) || 0) * 2 +
              tray * 2 +
              frame.get("width") / 5) *
            cm
          }px`,
        }}
      >
        {frame && criteria && cm ? (
          <Box
            sx={{
              position: "relative",
              width: `${
                (Number(props.item.specifications.width) +
                  (Number(props.item.specifications.mountboard.size) || 0) * 2 +
                  tray * 2 +
                  frame.get("width") / 5) *
                cm
              }px`,
              height: "auto",
            }}
          >
            <Box
              className={`cube__face`}
              sx={{
                borderImageSlice: "200",
                background: "transparent",
                boxShadow: "rgba(0, 0, 0, 0.7) 0px 2px 5px inset",
                transition: "all 800ms",
                borderStyle: "solid",
                borderImageSource: `url(${frame.get("frameImage").url()})`,
                borderImageWidth: `${(frame.get("width") / 10) * cm}px`,
                borderImageRepeat: "stretch",
                zIndex: "10",
                width: `${
                  (Number(props.item.specifications.width) +
                    (Number(props.item.specifications.mountboard.size) || 0) *
                      2 +
                    tray * 2 +
                    frame.get("width") / 5) *
                  cm
                }px`,
                height: `${
                  (Number(props.item.specifications.height) +
                    (Number(props.item.specifications.mountboard.size) || 0) *
                      2 +
                    tray * 2 +
                    frame.get("width") / 5) *
                  cm
                }px`,
              }}
            ></Box>
            <Box
              sx={{
                width: `${
                  (Number(props.item.specifications.width) +
                    (Number(props.item.specifications.mountboard.size) || 0) *
                      2 +
                    tray * 2) *
                    cm +
                  2
                }px`,
                height: `${
                  (Number(props.item.specifications.height) +
                    (Number(props.item.specifications.mountboard.size) || 0) *
                      2 +
                    tray * 2) *
                    cm +
                  2
                }px`,
                border: `${
                  (Number(props.item.specifications.mountboard.size) || 0) * cm
                }px solid #${props.item.specifications.mountboard.color}`,
                transition: "all 800ms",
                position: "absolute",
                zIndex: "10",
                left: `${(frame.get("width") / 10 + tray) * cm - 1}px`,
                top: `${(frame.get("width") / 10 + tray) * cm - 1}px`,
              }}
            ></Box>
            <Box
              sx={{
                width: `${Number(props.item.specifications.width) * cm + 4}px`,
                height: `${
                  Number(props.item.specifications.height) * cm + 4
                }px`,
                transition: "all 800ms",
                background: `url(${backBoardPic}) no-repeat center`,
                backgroundSize: "100% 100%",
                position: "absolute",
                zIndex: "20",
                objectFit: "fill",
                left: `${
                  ((Number(props.item.specifications.mountboard.size) || 0) +
                    frame.get("width") / 10 +
                    tray) *
                    cm -
                  2
                }px`,
                top: `${
                  ((Number(props.item.specifications.mountboard.size) || 0) +
                    frame.get("width") / 10 +
                    tray) *
                    cm -
                  2
                }px`,
              }}
            ></Box>
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              aspectRatio: 1,
              backgroundColor: "gray",
            }}
          ></Box>
        )}
      </Grid>

      <Grid
        item
        md={7.8}
        xs={12}
        sx={{
          py: 4,
          mt: { xs: 3, md: 0 },
          px: 1,
          pl: { md: 4 },
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "1000" }} component="h2">
          {props.item.title}
        </Typography>
        <Typography variant="h6">{frame.get("summary")}</Typography>
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
          container
        >
          <Grid item xs={7}>
            <Typography variant="subtitle1">Artwork Dimensions</Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="subtitle1">
              {props.item.specifications.width} x{" "}
              {props.item.specifications.height}
              cm
            </Typography>
            <Typography variant="subtitle2" sx={{ color: "gray" }}>
              Approx frame size:{" "}
              {props.item.specifications.width * 10 +
                tray * 20 +
                frame.get("width") * 2 +
                (props.item.specifications.mountboard.color
                  ? props.item.specifications.mountboard.size * 2
                  : 0)}{" "}
              x{" "}
              {props.item.specifications.height * 10 +
                tray * 20 +
                frame.get("width") * 2 +
                (props.item.specifications.mountboard.color
                  ? props.item.specifications.mountboard.size * 2
                  : 0)}{" "}
              mm
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
          container
        >
          <Grid item xs={7}>
            <Typography variant="subtitle1">Mount</Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="subtitle1">
              {props.item.specifications.mountboard.color
                ? `${
                    props.item.specifications.mountboard.color === "ffffff"
                      ? "White"
                      : props.item.specifications.mountboard.color === "fffbec"
                        ? "Soft White"
                        : props.item.specifications.mountboard.color ===
                            "212121"
                          ? "Black"
                          : ""
                  } - ${props.item.specifications.mountboard.size} cm`
                : "No Mount"}
            </Typography>
          </Grid>
        </Grid>
        {!tray && (
          <Grid
            sx={{
              display: "flex",
              py: 1,
              borderBottom: "2px solid #f3f4f5",
              width: "100%",
              alignItems: "center",
            }}
            container
          >
            <Grid item xs={7}>
              <Typography variant="subtitle1">Glazing</Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography variant="subtitle1">
                {props.item.specifications.glass}
              </Typography>
            </Grid>
          </Grid>
        )}
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Grid item xs={7}>
            <Typography
              variant="subtitle1"
              sx={{ width: { md: "20rem", xs: "12rem" } }}
            >
              Hanging Hardware
            </Typography>
          </Grid>
          <Grid item xs={5}>
            <Typography variant="subtitle1">Wire/D-Rings</Typography>
            <Tooltip title="Two D-rings and a Rope will be included for hanging">
              <Typography
                sx={{
                  backgroundColor: "gray",
                  borderRadius: "100%",
                  width: "1rem",
                  textAlign: "center",
                  color: "white",
                  ml: 1,
                  fontSize: "12px",
                  fontWeight: "1000",
                  cursor: "default",
                }}
              >
                ?
              </Typography>
            </Tooltip>
          </Grid>
        </Grid>
        {/* <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ width: {md:"20rem" ,xs:'10rem'} }}
          >
            Medium
          </Typography>

          <Typography variant="subtitle1">{props.item.specifications.paper}</Typography>
        </Grid> */}
        <Grid
          sx={{
            display: "flex",
            py: 1,
            borderBottom: "2px solid #f3f4f5",
            width: "100%",
            alignItems: "center",
          }}
        >
          <Grid item xs={7}>
            <Typography
              variant="subtitle1"
              sx={{ width: { md: "20rem", xs: "12rem" } }}
            >
              Quantity
            </Typography>
          </Grid>
          <Grid sx={{ display: "flex", gap: 1 }} item xs={5}>
            <button
              className={
                inputQuantity === 1
                  ? styles["quantity-disable"]
                  : styles["quantity-button"]
              }
              onClick={quantityDecHandler}
              disabled={inputQuantity === 1}
            >
              -
            </button>
            <Typography
              sx={{
                border: "2px solid #8d462b",
                borderRadius: 2,
                p: "2px 10px",
                width: "2.5rem",
                textAlign: "center",
              }}
            >
              {inputQuantity}
            </Typography>
            <button
              className={
                inputQuantity === quantity
                  ? styles["quantity-disable"]
                  : styles["quantity-button"]
              }
              onClick={quantityIncHandler}
              disabled={inputQuantity === quantity}
            >
              +
            </button>
          </Grid>{" "}
        </Grid>

        <br />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Link to={`/online-framing/edit`}>
              <button
                className={styles["edit-button"]}
                onClick={() => {
                  localStorage.setItem("editItemId", props.item.itemId);
                  localStorage.setItem(
                    "inputWidth",
                    props.item.specifications.width,
                  );
                  localStorage.setItem(
                    "inputHeight",
                    props.item.specifications.height,
                  );
                  localStorage.setItem("framingMode", "frame");
                }}
              >
                <SettingsIcon sx={{ fontSize: "27px" }} />
                Edit
              </button>
            </Link>

            <button
              className={styles["edit-button"]}
              onClick={deleteHandler}
              // id={.id}
            >
              <DeleteIcon sx={{ fontSize: "27px", mr: 1 }} /> Delete
            </button>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
            }}
          >
            <Typography component="h2" variant="h4">
              £
              {addCommas(
                (
                  (((perimeter + tray * 8 + (frame.get("width") / 10) * 8) *
                    frame.get("price")) /
                    100 +
                    (!tray
                      ? area *
                        (props.item.specifications.glass === "Art Acrylic 2mm"
                          ? UVAcrylic2mm
                          : UV99Acrylic2mm)
                      : 0) +
                    (props.item.specifications.mountboard.color
                      ? area * mount
                      : 0) +
                    (!tray ? area * backBoard : 0) +
                    hanging +
                    packing * frameArea) *
                  (1 + Number(VAT)) *
                  multiplierFactor *
                  inputQuantity
                ).toFixed(2),
              )}
            </Typography>
            <Typography sx={{ color: "gray", mt: 1 }} variant="subtitle2">
              incl. £
              {addCommas(
                (
                  (((perimeter + tray * 8 + (frame.get("width") / 10) * 8) *
                    frame.get("price")) /
                    100 +
                    (!tray
                      ? area *
                        (props.item.specifications.glass === "Art Acrylic 2mm"
                          ? UVAcrylic2mm
                          : UV99Acrylic2mm)
                      : 0) +
                    (props.item.specifications.mountboard.color
                      ? area * mount
                      : 0) +
                    (!tray ? area * backBoard : 0) +
                    hanging +
                    packing * frameArea) *
                  multiplierFactor *
                  inputQuantity *
                  Number(VAT)
                ).toFixed(2),
              )}{" "}
              VAT
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default FrameItem;
